import {
	CHANGE_PAGE,
	CHANGE_PARAMS,
	CHANGE_RESULTS_PER_PAGE,
	CHANGE_RESULTS_TOTAL,
	CHANGE_SORT,
	CHANGE_SORT_DIRECTION,
	CLEAR_SEARCH,
	RECEIVE_SEARCH_RESULT,
	RECEIVE_SEARCH_RESULT_FAILED,
	REQUEST_SEARCH_RESULT,
} from "./actions";
import { filterSearchParams } from "./filterSearchParams";

export function searchReducer(initialParams, chargeBeeFeatureFlagEnabled) {
	const initialState = {
		chargeBeeFeatureFlagEnabled: chargeBeeFeatureFlagEnabled === 1,
		params: initialParams,
		loading: false,
		result: undefined,
		resultsPage: 1,
		resultsPerPage: 20,
		resultsTotal: undefined,
		resultsSort: "id",
		resultsSortDirection: "desc",
		error: undefined,
	};

	return function (state = initialState, action) {
		switch (action.type) {
			case REQUEST_SEARCH_RESULT: {
				return Object.assign({}, state, {
					loading: true,
					error: undefined,
				});
			}
			case RECEIVE_SEARCH_RESULT: {
				return Object.assign({}, state, {
					result: action.data.result,
					loading: false,
					error: undefined,
				});
			}
			case RECEIVE_SEARCH_RESULT_FAILED: {
				return Object.assign({}, state, {
					loading: false,
					error: action.data.error,
				});
			}
			case CHANGE_PARAMS: {
				return Object.assign({}, state, {
					params: filterSearchParams(action.data.params),
				});
			}
			case CHANGE_PAGE: {
				return Object.assign({}, state, {
					resultsPage: action.data,
				});
			}
			case CHANGE_RESULTS_PER_PAGE: {
				return Object.assign({}, state, {
					resultsPerPage: action.data,
				});
			}
			case CHANGE_RESULTS_TOTAL: {
				return Object.assign({}, state, {
					resultsTotal: action.data,
				});
			}
			case CHANGE_SORT: {
				return Object.assign({}, state, {
					resultsSort: action.data,
				});
			}
			case CHANGE_SORT_DIRECTION: {
				return Object.assign({}, state, {
					resultsSortDirection: action.data,
				});
			}
			case CLEAR_SEARCH: {
				return Object.assign({}, state, {
					params: {},
					result: undefined,
					loading: false,
					error: undefined,
				});
			}
			default:
				return state;
		}
	};
}
